import { render, staticRenderFns } from "./ChannelDetailDialog.vue?vue&type=template&id=707610b6&scoped=true&"
import script from "./ChannelDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ChannelDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDetailDialog.vue?vue&type=style&index=0&id=707610b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707610b6",
  null
  
)

export default component.exports